import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserStatsState {
  wallet: {
    qcam: number;
    qcamCredit: number;
  };
  account: {
    bundleName: string;
    activeUpgrades: number;
  };
  loading: boolean;
}

interface ApiResponsePayload {
  qcamBalance: number;
  qcamCreditBalance: number;
  currentBundle: string;
  totalUpgrades: number;
}

const initialState: UserStatsState = {
  wallet: {
    qcam: 0,
    qcamCredit: 0,
  },
  account: {
    bundleName: '',
    activeUpgrades: 0,
  },
  loading: false,
};

const userStatsSlice = createSlice({
  name: 'userStats',
  initialState,
  reducers: {
    fetchDataStart: (state) => {
      // return a new state object instead of mutating `state`
      return {
        ...state,
        loading: true,
      };
    },

    setStoreData: (state, action: PayloadAction<ApiResponsePayload>) => {
      // return a new state object with nested copies
      return {
        ...state,
        loading: false,
        wallet: {
          ...state.wallet,
          qcam: action.payload.qcamBalance,
          qcamCredit: action.payload.qcamCreditBalance,
        },
        account: {
          ...state.account,
          bundleName: action.payload.currentBundle,
          activeUpgrades: action.payload.totalUpgrades,
        },
      };
    },
  },
});

export const { fetchDataStart, setStoreData } = userStatsSlice.actions;
export default userStatsSlice.reducer;
